import { ScheduleState } from "../../../type/schedule-state";

export const clearDialogScheduleDispatch = (state: ScheduleState) => {
  state.dialogSchedule = undefined;
  state.dialogDeliveryGroupIndex = undefined;
};
